import React, { Component } from 'react';
import PropTypes from 'prop-types';

class EmbeddedGist extends Component {
  static GistCallbackId = 0;
  static StylesheetAdded = false;

  isUnmounted = false;

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      src: '',
    };
  }

  // Each time we request a Gist, we'll need to generate a new
  // global function name to serve as the JSONP callback.    
  static nextGistCallback() {
    return `embed_gist_callback_${EmbeddedGist.GistCallbackId++}`;
  }

  // The Gist JSON data includes a stylesheet to add to the page
  // to make it look correct. `addStylesheet` ensures we only add
  // the stylesheet one time.
  static addStylesheet(href) {
    if (!EmbeddedGist.StylesheetAdded) {
      EmbeddedGist.StylesheetAdded = true;
      const link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = href;

      document.head.appendChild(link);
    }
  }

  componentDidMount() {
    // Create a JSONP callback that will set our state
    // with the data that comes back from the Gist site
    const gistCallback = EmbeddedGist.nextGistCallback();
    this.gistCallback = gistCallback;

    window[gistCallback] = ((gist) => {
      if (this.isUnmounted) {
        return;
      }

      this.setState({
        isLoading: false,
        src: gist.div
      });

      EmbeddedGist.addStylesheet(gist.stylesheet);
    });

    let url = `https://gist.github.com/${this.props.gist}.json?callback=${gistCallback}`;
    if (this.props.file) {
      url += `&file=${this.props.file}`;
    }

    // Add the JSONP script tag to the document.
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.head.appendChild(script);
  }

  componentWillUnmount() {
    this.isUnmounted = true
  }

  render() {
    if (this.state.isLoading) {
      return <div>Loading gist...</div>;
    } 
      
    return <div dangerouslySetInnerHTML={{__html: this.state.src}} />;
  }
}

EmbeddedGist.propTypes = {
  // e.g. "username/id"
  gist: PropTypes.string.isRequired,
  // to embed a single specific file from the gist
  file: PropTypes.string 
};

export default EmbeddedGist;